import createIcon from '../../createIcon';

/**
 * @component @name Unarchive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNTUgNS4yMkwxOS4xNiAzLjU0QzE4Ljg4IDMuMjEgMTguNDcgMyAxOCAzSDZDNS41MyAzIDUuMTIgMy4yMSA0Ljg1IDMuNTVMMy40NiA1LjIyQzMuMTcgNS41NyAzIDYuMDEgMyA2LjVWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNi41QzIxIDYuMDEgMjAuODMgNS41NyAyMC41NSA1LjIyWk0xMiA5LjVMMTcuNSAxNUgxNFYxN0gxMFYxNUg2LjVMMTIgOS41Wk01LjEyIDVMNS45NCA0SDE3Ljk0TDE4Ljg3IDVINS4xMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Unarchive = createIcon('Unarchive', [
  [
    'path',
    {
      d: 'M20.55 5.22L19.16 3.54C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.85 3.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.01 20.83 5.57 20.55 5.22ZM12 9.5L17.5 15H14V17H10V15H6.5L12 9.5ZM5.12 5L5.94 4H17.94L18.87 5H5.12Z',
      key: 'oir6do',
    },
  ],
]);

export default Unarchive;
